/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable guard-for-in */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-control-statements/jsx-use-if-tag */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-useless-escape */
/* eslint-disable complexity */
/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import {
  Spacer,
  Field,
  Button,
  Label,
  Divider,
  Checkbox,
  Card,
  Icon,
  Row,
  Col,
  Collapse
} from '@cleartrip/bento'
import {
  validateEmail,
  validateMobileNumber,
  validatePassword,
  onlyNumbersRegex,
  validateLastName,
  validateFirstName
} from 'AccountsUtils'

import { isEmpty, resolveKeysInObjectsArrays } from 'AccountsUtils'

import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'

import Modal from './Modal'
import {
  userSignIn,
  userResetPassword,
  userSignUp
} from '../../pages/Trips/trips.helper'
import Dropdown from './Dropdown'
import USER_PROFILE_PAGE_CONTANTS from './UserProfileConstants'
import ModalHeader from './UserProfileModalHeader'

import Sign from './screens/Sign'
import LoginWithMobile from './screens/loginWithMobile'
import VerifyMobileNumber from './screens/VerifyMobileNumber'
import EmailsLinked from './screens/EmailsLinked'
import VerifyEmail from './screens/VerifyEmail'
import LinkAccounts from './screens/LinkAccounts'
import VerifyMobileInputField from './screens/VerifyMobileField'
import ResetPassword from './screens/ResetPassword'
import CheckYourEmail from './screens/CheckYourEmail'
import LinkAccountsSuccess from './screens/AccountsLinkSuccess'
import Loader from './screens/Loader/Loader'
import PersonalDetails from './screens/PersonalDetails'
import EmailLinkedPersonalDetails from './screens/VerifiedEmailPersonalDetails'

const isRtl = process.env.CONTENT_DIR === 'RTL'
function ViewContainer({ isPwa, isShowing, toggle, page, handleIsShowing,emailsLinkedInTrips, abLogin = 'a', showFkSSO='b',showFkSSOPwa='b' }) {
  const MOBILE_COUNTRY_CODES = {
    IN: { name: 'India', code: '91', min: 10, max: 10 }
  }

  const countryCode = 'IN'

  const defaultCode = MOBILE_COUNTRY_CODES[countryCode].code || ''
  const defaultMinLength = MOBILE_COUNTRY_CODES[countryCode].min || ''
  const defaultMaxLength = MOBILE_COUNTRY_CODES[countryCode].max || ''

  const [pageName, setPageName] = useState(page)
  const [showPasswordRules, setShowPasswordRules] = useState(false)
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }
  const [animationParams, setAnimationParams] = useState(animationDefaultState)
  // const [isAnimate, setIsAnimate] = useState(false)
  const [showGSTIN, setShowGSTIN] = useState(false)
  const [rememberCheckedStatus, setRememberCheckedStatus] = useState(true)
  const [travelCheckedStatus, setTravelCheckedStatus] = useState(false)
  const [signInError, setSignInError] = useState(false)
  const [isSignInButtonLoading, setSignInButtonLoading] = useState(false)
  const [userSignedIn, setUserSignedIn] = useState(false)
  const [email, setEmail] = useState('')
  const [isEmailValid, setEmailValid] = useState(true)
  const [firstName, setFirstName] = useState('')
  const [isValidFirstName, setFirstNameValid] = useState(true)
  const [accountExists, setAccountExists] = useState(false)
  const [lastName, setLastName] = useState('')
  const [isValidLastName, setLastNameValid] = useState(true)
  const [gstin, setGstin] = useState('')
  const [isGSTValid, setGSTValid] = useState(true)
  const [companyName, setCompanyName] = useState('')
  const [isCompanyValid, setCompanyValid] = useState(true)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isPasswordValid, setPasswordValid] = useState(true)
  const [isConfirmPasswordValid, setConfirmPasswordValid] = useState(true)
  const [defaultCountryCode, setDefaultCountryCode] = useState(
    isRtl ? `${defaultCode}+` : `+${defaultCode}`
  )
  const [defaultCountryCodeMinLen, setDefaultCountryCodeMinLen] = useState(
    defaultMinLength
  )
  const [defaultCountryCodeMaxLen, setDefaultCountryCodeMaxLen] = useState(
    defaultMaxLength
  )
  const [isMobileValid, setMobileValid] = useState(true)
  const [passwordType, setPasswordType] = useState(true)
  const [confirmPasswordType, setConfirmPasswordType] = useState(true)
  const [signInPasswordType, setSignInPasswordType] = useState(true)
  const [toggleGender, setToggleGender] = useState(false)
  const [gender, setGender] = useState('')
  const [genderError, setGenderError] = useState(false)
  const [mobileNumber, setMobileNumber] = useState('')
  const [toggleDropdown, setToggleDropdown] = useState(false)
  const [signUpFormError, setSignUpFormError] = useState(false)
  const [showEmailNotFound, setShowEmailNotFound] = useState(false)
  const [linkedEmails, setLinkedEmails] = useState([])
  const [isFocus, setFocus] = useState(false)
  const errorRef = useRef(null)
  const [initialRender, setInitialRender] = useState(true)
  const gstinRegex = new RegExp(
    '^((0[1-9])|([1-2][0-9])|(3[0-6]))[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[A-Za-z0-9]{3}?$'
  )
  const oneSpecialCharacterRegex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
  const lowerCaseRegex = /[a-z]/
  const uperCaseRegex = /[A-Z]/
  const numberRegex = /[0-9]/
  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-8': 'px-8'
  })
  const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
  const pathname = query.split('/')
  const pagePath = pathname[2]

  useEffect(() => {
    if (!isShowing) {
      setPageName(null)
      setShowPasswordRules(false)
      setShowGSTIN(false)
    } else setPageName(page)
  }, [page, isShowing])

  useEffect(() => {
    if (pageName === 'SIGNIN' || pageName === 'RESET') {
      setToDefault()
    } else if (pageName === 'EMAIL_MOBILE_LINKED') {
      setMobileValid(true)
      setMobileNumber('')
      setToggleDropdown(false)
    }
  }, [pageName])

  function goBackAnimation(page) {
    setAnimationParams({
      isAnimate: true,
      direction: 'left'
    })
    setTimeout(() => {
      clickHandler(page, false)
    }, 200)
  }

  function clickHandler(page, isAnimate) {
    setAnimationParams({ isAnimate, direction: isRtl ? 'left' : 'right' })

    setPageName(page)
    setTimeout(() => {
      setAnimationParams(animationDefaultState)
    }, 300)
  }

  const executeScroll = () => errorRef.current.scrollIntoView()
  const resendResetPassword = async () => {
    const resetPwdResponse = await userResetPassword(email)

    const { status: resetPwdStatus } = resetPwdResponse || {}

    if (resetPwdStatus == 202) {
      return true
    }
    return false
  }
  const resetPassword = async (page, isAnimate, email) => {
    const validateEmail = validateEmailHandler()
    if (!validateEmail) {
      ClevertapEvent({
        actionName: 'Invalid_value_entered',
        actionType: 'Button',
        login_banner_cookie: abLogin,
        page:
          pagePath === 'results'
            ? 'SRP'
            : isEmpty(pagePath)
            ? 'HP'
            : pathname.length > 4 &&
              pathname[4] === 'info' &&
              pathname[2] === 'itinerary'
            ? 'Itinerary'
            : 'Confirmation_Page',

        field_name: 'email',
        form_name: 'ResetPassword'
      })
      setEmailValid(validateEmail)
    } else {
      const resetPwdResponse = await userResetPassword(email)

      const { status: resetPwdStatus } = resetPwdResponse || {}

      if (resetPwdStatus == 202) {
        setAnimationParams({ isAnimate, direction: 'right' })

        setPageName(page)
        setTimeout(() => {
          setAnimationParams(animationDefaultState)
        }, 300)
      } else {
        setShowEmailNotFound(true)
        setEmailValid(false)
      }
    }
  }

  const setToDefault = () => {
    setMobileValid(true)
    setEmailValid(true)
    setPasswordValid(true)
    setConfirmPasswordValid(true)
    setShowEmailNotFound(false)
    setSignInError(false)
    setShowGSTIN(false)
    setEmail('')
    setFirstName('')
    setFirstNameValid(true)
    setLastName('')
    setLastNameValid(true)
    setGSTValid(true)
    setGstin('')
    setCompanyName('')
    setCompanyValid(true)
    setPassword('')
    setConfirmPassword('')
    setPasswordType(true)
    setConfirmPasswordType(true)
    setSignInPasswordType(true)
    setToggleGender(false)
    setGender('')
    setMobileNumber('')
    setToggleDropdown(false)
    setSignUpFormError(false)
    setGenderError(false)
    setAccountExists(false)
    // can add more default states if needed
  }

  const renderPage = () => {
    switch (pageName) {
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN:
        return MobileSignInUpBlock
      case USER_PROFILE_PAGE_CONTANTS.RESET_PAGE:
        return ResetBlock
      case USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE:
        return MobileSignInUpBlock
      case USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE:
        return ResetConfirmationBlock

      case USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER:
        return VerifyNumberBlock
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED:
        return EmailLinked
      case USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAIL:
        return VerifyEmailBlock
      case USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS:
        return LinkAccountsBlock
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAIL:
        return SigninBlock
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED:
        return VerifyMobileInputFieldBlock
      case USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS:
        return LinkAccountsSuccessBlock
      case USER_PROFILE_PAGE_CONTANTS.LOADER:
        return LoaderBlock
      case USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS:
        return PersonalDetailsBlock
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED_PERSONAL_DETAILS:
        return EmailLinkedPersonalDetailsBlock
      default:
        return null
    }
  }

  const handleLinkClick = url => {
    const dest = `${window.location.origin}/${url}`
    window.open(dest, '_blank')
  }
  const changeEmailHandler = e => {
    setEmailValid(true)
    setShowEmailNotFound(false)
    setEmail(e.target.value)
  }
  const validateEmailHandler = e => {
    const temp = validateEmail(email)
    setEmailValid(temp)
    return temp
  }

  const handleOnFocus = () => {
    setFocus(true)
  }
  const changeCompanyHandler = e => {
    let companyValid = true
    setCompanyName(e.currentTarget.value)
    companyValid = !isEmpty(companyName)
    setCompanyValid(companyValid)
  }
  const changeGstinHandler = e => {
    const gstin = e.currentTarget.value
    if (gstin.length <= 15) {
      setGstin(gstin.toUpperCase())
    }
    setGSTValid(true)
  }
  const changeFirstNameHandler = e => {
    setFirstNameValid(true)
    setFirstName(e.target.value)
  }
  const changeLastNameHandler = e => {
    setLastNameValid(true)
    setLastName(e.target.value)
  }
  const validateFirstNameHandler = e => {
    const temp = validateFirstName(firstName, 32)

    setFirstNameValid(temp)
    return temp
  }
  const validateLastNameHandler = e => {
    const temp = validateLastName(lastName, 1, 32)
    setLastNameValid(temp)
    return temp
  }
  const changePasswordHandler = e => {
    setPasswordValid(true)
    setPassword(e.target.value)
  }
  const changeConfirmPasswordHandler = e => {
    setConfirmPasswordValid(true)
    setConfirmPassword(e.target.value)
  }

  const validatePasswordHandler = e => {
    const temp = validatePassword(password)
    setPasswordValid(temp)
    return temp
  }
  const validateConfirmPasswordHandler = e => {
    const temp = confirmPassword === password
    setConfirmPasswordValid(temp)
    return temp
  }

  const validateMobileHandler = e => {
    const isMobileValid = validateMobileNumber(
      mobileNumber,
      defaultCountryCodeMinLen,
      defaultCountryCodeMaxLen
    )
    setMobileValid(isMobileValid)
    return isMobileValid
  }
  const changeMobileHandler = e => {
    const mobile = e.target.value
    if (!isEmpty(mobile) && !onlyNumbersRegex.test(mobile)) {
      return
    }
    if (mobile.length <= defaultCountryCodeMaxLen) {
      setMobileValid(true)
      setMobileNumber(mobile)
    }
  }
  const countryCodeHandler = (code, min, max) => {
    if (isRtl) setDefaultCountryCode(`${code}+`)
    else setDefaultCountryCode(`+${code}`)
    setDefaultCountryCodeMinLen(min)
    setDefaultCountryCodeMaxLen(max)
    setToggleDropdown(toggleDropdown === code ? true : code)
    setMobileValid(true)
  }
  const mobileCountryCodesItem = codeObj => {
    const { name, code, min, max } = codeObj
    return (
      <Dropdown.Item
        selected={`+${code}` === defaultCountryCode}
        className="fs-3  hover:bg-secondary-500 c-pointer hover:c-white"
        onClick={() => countryCodeHandler(code, min, max)}
      >
        {name} (+{code})
      </Dropdown.Item>
    )
  }
  const populateMobileCountryCode = () => {
    const mobileCountryCodes = []
    // for (const popularCountry of POPULAR_MOBILE_COUNTRY) {
    //   const codeObj = MOBILE_COUNTRY_CODES[popularCountry]
    //   mobileCountryCodes.push(mobileCountryCodesItem(codeObj))
    // }
    for (const countryCode in MOBILE_COUNTRY_CODES) {
      const codeObj = MOBILE_COUNTRY_CODES[countryCode]
      mobileCountryCodes.push(mobileCountryCodesItem(codeObj))
    }
    return mobileCountryCodes
  }
  const selectGender = e => {
    const arabicGenderMapping = {
      Male: 'Male',
      Female: 'Female'
    }
    const selectedGender = arabicGenderMapping[e.currentTarget.innerText] || ''

    // onChangeHandler(traveller, 'gender', selectedGender)
    setGender(selectedGender)
    setToggleGender(toggleGender === selectedGender ? true : selectedGender)
    setGenderError(false)
  }

  const toggleModalAndClosePage = () => {
    setTimeout(() => {
      toggle()
    }, 300)
    setTimeout(() => {
      window.location.reload()
    }, 400)
  }
  const dismissalPage = () => {
    switch (pageName) {
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN:
        return 'Entering_mobile_number'
      case USER_PROFILE_PAGE_CONTANTS.RESET_PAGE:
        return 'Enter_email_for_reset'
      case USER_PROFILE_PAGE_CONTANTS.SIGNUP_PAGE:
        return 'Entering_mobile_number'
      case USER_PROFILE_PAGE_CONTANTS.RESET_CONFIRMATION_PAGE:
        return 'Reset_password_link_sent'
      case USER_PROFILE_PAGE_CONTANTS.SIGNEDIN_USER_PAGE:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.SIGNUP_FORM_PAGE:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER:
        return 'Entering_OTP'
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED:
        return 'Selecting_linked_emails'
      case USER_PROFILE_PAGE_CONTANTS.VERIFY_EMAIL:
        return 'Entering_OTP'
      case USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS:
        return 'Linking_accounts'
      case USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAIL:
        return 'Email_login'
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED:
        return 'Enterig_mobile_number_after_email_sign_in'
      case USER_PROFILE_PAGE_CONTANTS.LINK_SUCCESS:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.LOADER:
        return ''
      case USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS:
        return 'Enter_personal_details'
      case USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED_PERSONAL_DETAILS:
        return 'Email_linked_personal_details'
      default:
        return ''
    }
  }
  function handleSignInToggle() {
    setMobileNumber('')
    const dismissalPoint = dismissalPage()
    ClevertapEvent({
      actionName: 'Login_modal_dismissed',
      actionType: 'Button',
      page:
        pagePath === 'results'
          ? 'SRP'
          : isEmpty(pagePath)
          ? 'HP'
          : pathname.length > 4 &&
            pathname[4] === 'info' &&
            pathname[2] === 'itinerary'
          ? 'Itinerary'
          : 'Confirmation_Page',

      point_of_dismissal: dismissalPoint
    })
    if (userSignedIn) {
      toggleModalAndClosePage()
    } else {
      setInitialRender(true)
      toggle()
    }
  }
  let spanClass =
    'fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex flex-middle r-2 fw-500 t-0'
  if (isRtl) {
    spanClass =
      'fs-2 c-secondary-500 c-pointer hover:td-underline p-absolute h-9 flex flex-middle l-2 fw-500 t-0'
  }
  let checkboxClass = 'nl-1'
  if (isRtl) {
    checkboxClass = ''
  }
  let checkBoxTextClass = 'pl-1 c-neutral-700  fs-2 nl-1'
  if (isRtl) {
    checkBoxTextClass = 'pr-2 c-neutral-700  fs-2 '
  }

  let errorInfo = 'fs-inherit c-inherit pl-2'
  if (isRtl) {
    errorInfo = 'fs-inherit c-inherit pr-2'
  }

  const mobileAndCountryCodeItem = isRtl ? (
    <Row>
      <Col>
        <Field
          type="tel"
          placeholder="Enter mobile number"
          onChange={changeMobileHandler}
          onBlur={validateMobileHandler}
          hasError={!isMobileValid}
          value={mobileNumber}
          style={{ direction: 'ltr' }}
        />
        {!isMobileValid &&
          (mobileNumber.length === 0 ? (
            <div className="c-error-500 fs-2 mt-1">
              {'Please enter a phone number'}
            </div>
          ) : (
            <div className="c-error-500 fs-2 mt-1">
              {'Please enter a valid phone number'}
            </div>
          ))}
      </Col>
      <Col span="7">
        <Dropdown overlay={false} toggle={toggleDropdown}>
          <Dropdown.Select
            className="h-9 p-0 px-2 fs-3"
            width={80}
            label={defaultCountryCode}
          />
          <Dropdown.Menu
            width={300}
            className="oy-auto"
            style={{ maxHeight: '198px' }}
          >
            {populateMobileCountryCode()}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  ) : (
    <Row>
      <Col span="6">
        <Dropdown overlay={false} toggle={toggleDropdown}>
          <Dropdown.Select
            hasError={
              !isMobileValid && defaultCountryCodeMaxLen < mobileNumber.length
            }
            className="h-9 p-0 px-2 fs-3"
            width={80}
            label={defaultCountryCode}
          />
          <Dropdown.Menu
            width={196}
            className="oy-auto"
            style={{ maxHeight: '198px' }}
          >
            {populateMobileCountryCode()}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
      <Col>
        <Field
          data-testid="Mobile"
          type="tel"
          placeholder="Enter mobile number"
          onChange={changeMobileHandler}
          onBlur={validateMobileHandler}
          hasError={!isMobileValid}
          onFocus={handleOnFocus}
          value={mobileNumber}
        />
        {!isMobileValid &&
          (mobileNumber.length === 0 ? (
            <div className="c-error-500 fs-2 mt-1">
              {'Please enter a phone number'}
            </div>
          ) : (
            defaultCountryCodeMaxLen >= mobileNumber.length && (
              <div
                data-testid="invalidMobileMessage"
                className="c-error-500 fs-2 mt-1"
              >
                {'Please enter a valid phone number'}
              </div>
            )
          ))}
      </Col>
      {!isMobileValid && defaultCountryCodeMaxLen < mobileNumber.length && (
        <div
          data-testid="invalidMobileMessage"
          className="ml-2 c-error-500 fs-2 mt-1"
        >
          {'Please check your country code and phone number.'}
        </div>
      )}
    </Row>
  )

  async function redirectToPage() {
    // TODO add api call
    if (isEmpty(email)) {
      setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
    } else {
      setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
    }
  }

  const signUpCreate = async () => {
    let signUpError = false
    if (isEmpty(password)) {
      setPasswordValid(false)
      signUpError = true
    } else if (
      !uperCaseRegex.test(password) ||
      !numberRegex.test(password) ||
      !lowerCaseRegex.test(password) ||
      !oneSpecialCharacterRegex.test(password) ||
      password.length < 8
    ) {
      setPasswordValid(false)
      signUpError = true
    }
    if (isEmpty(confirmPassword)) {
      setConfirmPasswordValid(false)
      signUpError = true
    }
    if (isEmpty(firstName)) {
      setFirstNameValid(false)
      signUpError = true
    }
    if (isEmpty(lastName)) {
      setLastNameValid(false)
      signUpError = true
    }
    if (!isConfirmPasswordValid) {
      signUpError = true
    }
    if (!isValidFirstName) {
      signUpError = true
    }
    if (!isValidLastName) {
      signUpError = true
    }
    if (isEmpty(gender)) {
      setGenderError(true)
      signUpError = true
    }
    if (!validateMobileHandler()) {
      setMobileValid(false)
      signUpError = true
    }
    if (showGSTIN) {
      if (isEmpty(companyName)) {
        setCompanyValid(false)
        signUpError = true
      }
      if (isEmpty(gstin)) {
        setGSTValid(false)
        signUpError = true
      } else if (!gstinRegex.test(gstin)) {
        setGSTValid(false)
        signUpError = true
      }
    }

    if (signUpError) {
      setSignUpFormError(true)
      setTimeout(() => {
        executeScroll()
      }, 200)
    } else {
      setSignUpFormError(false)
      const countryCode = defaultCountryCode.substring(1)
      const payload = {
        username: email,
        gstDetails: [
          {
            id: '',
            gstHolderAddress: null,
            gstHolderName: '',
            gstHolderStateCode: null,
            gstHolderStateName: null,
            gstNumber: gstin
          }
        ],
        companyDetails: [
          {
            companyName,
            domain: window.location.domain,
            status: '1'
          }
        ],
        travellerDetails: [
          {
            isRegistered: true,
            profileData: null,
            contactInfo: {
              phoneNumbers: [
                {
                  mobileNumber,
                  mobileCountryCode: countryCode,
                  category: 'mobile'
                }
              ],
              whatsapp: null,
              addresses: [],
              otherDetails: [],
              emails: []
            },
            ffnPreferences: null,
            personalDetails: {
              anniversaryDate: null,
              companyDesignation: null,
              concatName: `${firstName}${lastName}${email}`,
              countryOfResidence: null,
              countryOfResidenceId: null,
              countryPreference: null,
              currency: null,
              dateOfBirth: null,
              department: null,
              emergencyContactName: null,
              emergencyContactNumber: null,
              firstName: `${firstName}`,
              gender: `${gender}`,
              homeAirport: null,
              homeAirportId: null,
              language: null,
              lastName: `${lastName}`,
              middleName: null,
              nickName: null,
              primaryEmail: null,
              title: ''
            },
            preferences: null,
            docDetails: null
          }
        ],
        password
      }

      const apiResponse = await userSignUp(payload)
      const { status, error } = apiResponse
      if (error && error.response && error.response.status === 403) {
        setAccountExists(true)
      } else if (status === 202) {
        const payload = {
          username: email,
          password
        }

        const apiResponse = await userSignIn(payload)
        setTimeout(() => {
          handleIsShowing()
        }, 300)
        setTimeout(() => {
          window.location.reload()
        }, 400)
      } else {
        setSignUpFormError(true)
      }
    }
  }
  useEffect(()=>{
    if(!isEmpty(emailsLinkedInTrips)){
      console.log("checkInside")
      setLinkedEmails(emailsLinkedInTrips);
    }
  },[emailsLinkedInTrips])

  const onContinue = async () => {
    // Reset Error
    setSignInButtonLoading(true)
    setSignInError('')
    const emailValidation = validateEmailHandler()
    setEmailValid(emailValidation)
    if (emailValidation && isEmailValid && email) {
      const isValidPassword = validatePasswordHandler()
      if (!isValidPassword) {
        ClevertapEvent({
          actionName: 'Invalid_value_entered',
          actionType: 'Button',
          login_banner_cookie: abLogin,
          page:
            pagePath === 'results'
              ? 'SRP'
              : isEmpty(pagePath)
              ? 'HP'
              : pathname.length > 4 &&
                pathname[4] === 'info' &&
                pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page',

          field_name: 'password',
          form_name: 'EmailLogin'
        })
        setSignInButtonLoading(false)
        return false
      }

      const payload = {
        username: email,
        password
      }

      const apiResponse = await userSignIn(payload)
      console.log('Sign in Response', apiResponse)
      const { data, status } = apiResponse
      const { status: dataStatus } = data || {}

      if (status !== 200 || dataStatus === 'INTERNAL_SERVER_ERROR') {
        const {
          error: { response: { data: { message = '' } = {} } = {} } = {}
        } = apiResponse
        if (
          apiResponse.error.response.status === 410 &&
          apiResponse.error.response.data.message === 'AUTHENTICATION_ERROR'
        ) {
          setSignInError('Password doesn’t exist or has expired.')
          setPasswordValid(false)
        } else if (message.includes('username and password do not match')) {
          setSignInError('Entered email and password does not match.')

          setPasswordValid(false)
        } else if (message.includes('no user found')) {
          setSignInError('Entered email is not found')
          setEmailValid(false)
          setPasswordValid(false)
        } else {
          setSignInError('Something went wrong. Please try again.')
        }
        setSignInButtonLoading(false)
        return false
      }
      if (status == 200) {
        ClevertapEvent({
          actionName: 'Login_succesful',
          actionType: 'Button',
          action: 'signin',
          login_banner_cookie: abLogin,
          page:
            pagePath === 'results'
              ? 'SRP'
              : isEmpty(pagePath)
              ? 'HP'
              : pathname.length > 4 &&
                pathname[4] === 'info' &&
                pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page',

          login_type: 'Email',
          first_time_login: 'No',
          keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
        })
        setUserSignedIn(true)
        window.localStorage.setItem('LoginToastShown','true')
        // TODO-AB : OTP case
        const { user = {} } = data || {}
        if (
          (!isEmpty(user.mobile) && !isEmpty(user.countryCode)) ||
          (user.peopleNudge && user.peopleNudge.mobile === true) ||
          (pathname.length > 4 &&
            pathname[4] === 'info' &&
            pathname[2] === 'itinerary')
        ) {
          setTimeout(() => {
            window.location.reload()
          }, 100)
        } else {
          setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
        }

        // if(data.showMobile)
        // {
        // }
        //                 else if(data.LinkAccounts)
        //                 {
        // setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
        //                 }
        // else{
        // setTimeout(() => {
        //     window.location.reload()
        // }, 100)
        // }
        setSignInButtonLoading(false)
      }
    } else {
      ClevertapEvent({
        actionName: 'Invalid_value_entered',
        actionType: 'Button',
        login_banner_cookie: abLogin,
        page:
          pagePath === 'results'
            ? 'SRP'
            : isEmpty(pagePath)
            ? 'HP'
            : pathname.length > 4 &&
              pathname[4] === 'info' &&
              pathname[2] === 'itinerary'
            ? 'Itinerary'
            : 'Confirmation_Page',

        field_name: 'email',
        form_name: 'EmailLogin'
      })
      setSignInButtonLoading(false)
    }
  }

  const SigninBlock = (
    <Sign
      isPwa={isPwa}
      isFocus={isFocus}
      animatedClass={animatedClass}
      toggle={handleSignInToggle}
      signInError={signInError}
      validateEmailHandler={validateEmailHandler}
      changeEmailHandler={changeEmailHandler}
      isEmailValid={isEmailValid}
      email={email}
      validatePasswordHandler={validatePasswordHandler}
      changePasswordHandler={changePasswordHandler}
      isPasswordValid={isPasswordValid}
      password={password}
      spanClass={spanClass}
      checkboxClass={checkboxClass}
      rememberCheckedStatus={rememberCheckedStatus}
      setRememberCheckedStatus={setRememberCheckedStatus}
      checkBoxTextClass={checkBoxTextClass}
      onContinue={onContinue}
      isLoading={isSignInButtonLoading}
      errorInfo={errorInfo}
      pagePath={pagePath}
      clickHandler={clickHandler}
      handleLinkClick={handleLinkClick}
      setPageName={setPageName}
      signInPasswordType={signInPasswordType}
      setSignInPasswordType={setSignInPasswordType}
      abLogin={abLogin}
    />
  )

  const MobileSignInUpBlock = (
    <LoginWithMobile
      isPwa={isPwa}
      isFocus={isFocus}
      mobileAndCountryCodeItem={mobileAndCountryCodeItem}
      setPageName={setPageName}
      validateMobileHandler={validateMobileHandler}
      isMobileValid={isMobileValid}
      handleLinkClick={handleLinkClick}
      toggle={handleSignInToggle}
      email={email}
      mobile={mobileNumber}
      countryCode={defaultCountryCode}
      setMobileValid={setMobileValid}
      initialRender={initialRender}
      setInitialRender={setInitialRender}
      abLogin={abLogin}
      showFkSSO={showFkSSO}
      showFkSSOPwa={showFkSSOPwa}
    />
  )
  const VerifyNumberBlock = (
    <VerifyMobileNumber
      isPwa={isPwa}
      isFocus={isFocus}
      toggle={handleSignInToggle}
      mobileNumber={mobileNumber}
      defaultCountryCode={defaultCountryCode}
      setPageName={setPageName}
      checkboxClass={checkboxClass}
      rememberCheckedStatus={rememberCheckedStatus}
      setRememberCheckedStatus={setRememberCheckedStatus}
      checkBoxTextClass={checkBoxTextClass}
      redirectToPage={redirectToPage}
      email={email}
      setMobileNumber={setMobileNumber}
      toggleModalAndClosePage={toggleModalAndClosePage}
      setLinkedEmails={setLinkedEmails}
      setUserSignedIn={setUserSignedIn}
      abLogin={abLogin}
    />
  )
  const VerifyMobileInputFieldBlock = (
    <VerifyMobileInputField
      mobileAndCountryCodeItem={mobileAndCountryCodeItem}
      setPageName={setPageName}
      validateMobileHandler={validateMobileHandler}
      isMobileValid={isMobileValid}
      handleLinkClick={handleLinkClick}
      toggle={handleSignInToggle}
      email={email}
      mobile={mobileNumber}
      countryCode={defaultCountryCode}
      abLogin={abLogin}
    />
  )
  const VerifyEmailBlock = (
    <VerifyEmail
      toggle={handleSignInToggle}
      email={email}
      setPageName={setPageName}
      checkboxClass={checkboxClass}
      rememberCheckedStatus={rememberCheckedStatus}
      setRememberCheckedStatus={setRememberCheckedStatus}
      checkBoxTextClass={checkBoxTextClass}
      redirectToPage={redirectToPage}
      toggleModalAndClosePage={toggleModalAndClosePage}
    />
  )
  const EmailLinked = (
    <EmailsLinked
      toggle={handleSignInToggle}
      mobileNumber={mobileNumber}
      defaultCountryCode={defaultCountryCode}
      email={email}
      linkedEmails={linkedEmails}
      setEmail={setEmail}
      setPageName={setPageName}
      handleLinkClick={handleLinkClick}
    />
  )
  const LinkAccountsBlock = (
    <LinkAccounts
      handleLinkClick={handleLinkClick}
      toggle={handleSignInToggle}
      setPageName={setPageName}
      email={email}
      toggleModalAndClosePage={toggleModalAndClosePage}
    />
  )
  const LoaderBlock = <Loader />
  const LinkAccountsSuccessBlock = <LinkAccountsSuccess />

  const PersonalDetailsBlock = (
    <PersonalDetails
      email={email}
      validateEmailHandler={validateEmailHandler}
      changeEmailHandler={changeEmailHandler}
      isEmailValid={isEmailValid}
      travelCheckedStatus={travelCheckedStatus}
      setTravelCheckedStatus={setTravelCheckedStatus}
      changeLastNameHandler={changeLastNameHandler}
      isValidLastName={isValidLastName}
      lastName={lastName}
      validateLastNameHandler={validateLastNameHandler}
      changeFirstNameHandler={changeFirstNameHandler}
      isValidFirstName={isValidFirstName}
      firstName={firstName}
      validateFirstNameHandler={validateFirstNameHandler}
      toggle={handleSignInToggle}
      gender={gender}
      setGender={setGender}
      validateEmail={validateEmail}
      setEmail={setEmail}
      errorInfo={errorInfo}
      toggleModalAndClosePage={toggleModalAndClosePage}
    />
  )
  const EmailLinkedPersonalDetailsBlock = (
    <EmailLinkedPersonalDetails
      email={email}
      validateEmailHandler={validateEmailHandler}
      changeEmailHandler={changeEmailHandler}
      isEmailValid={isEmailValid}
      travelCheckedStatus={travelCheckedStatus}
      setTravelCheckedStatus={setTravelCheckedStatus}
      changeLastNameHandler={changeLastNameHandler}
      isValidLastName={isValidLastName}
      lastName={lastName}
      validateLastNameHandler={validateLastNameHandler}
      changeFirstNameHandler={changeFirstNameHandler}
      isValidFirstName={isValidFirstName}
      firstName={firstName}
      validateFirstNameHandler={validateFirstNameHandler}
      toggle={handleSignInToggle}
      gender={gender}
      setGender={setGender}
      validateEmail={validateEmail}
      setEmail={setEmail}
      errorInfo={errorInfo}
      toggleModalAndClosePage={toggleModalAndClosePage}
    />
  )
  const ResetBlock = (
    <ResetPassword
      toggle={handleSignInToggle}
      validateEmailHandler={validateEmailHandler}
      changeEmailHandler={changeEmailHandler}
      isEmailValid={isEmailValid}
      email={email}
      resetPassword={resetPassword}
      validateEmail={validateEmail}
    />
  )

  const ResetConfirmationBlock = (
    <CheckYourEmail
      toggle={handleSignInToggle}
      setPageName={setPageName}
      setEmail={setEmail}
      clickHandler={clickHandler}
      email={email}
      resendResetPassword={resendResetPassword}
    />
  )

  return (
    <Modal
      isShowing={isShowing}
      overlayClassName="z-70"
      overlayStyle={{ zIndex: 10000 }}
    >
      {renderPage()}
    </Modal>
  )
}

export default ViewContainer
